export default __webpack_public_path__ + "static/default-bc920f4fb57b5fea0cad0a9a800a7deb.jpg";